import React, { memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "./OurProjects.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import { OurSolIcon } from "../../assets/img";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import { FiArrowDownLeft, FiArrowDownRight } from "react-icons/fi";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

const OurProjects = memo(({ title, description, sliderData }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const renderSwiperSlide = (project, idx) => (
		<SwiperSlide key={idx}>
			<Fade direction='up' triggerOnce={true}>
				<div className='bg-white shadow-lg rounded-ss-[6rem] rounded-l-[6rem] overflow-hidden pt-0 px-0 rounded-lg group hover:shadow-xl custom-transition text-center py-4 pb-0'>
					<div className='m-auto max-h-[160px] h-[160px] overflow-hidden mb-4'>
						<img
							className='group-hover:translate-y-2 group-hover:scale-125 scale-110 custom-transition max-h-full w-full object-cover rounded-lg custom-transition-animations'
							src={project?.image}
							alt={project?.title || "Project Image"}
						/>
					</div>
					<h4 className='h-8 text-slate-900 font-medium text-xl'>
						{project.title}
					</h4>
					<p
						dangerouslySetInnerHTML={{ __html: project?.description }}
						className='h-12 text-slate-600 font-normal text-[16px] mb-3 px-2 webkit-line-clamp-description'
					/>
					<Link
						className='group flex justify-center items-center text-second_color hover:text-semi_second_color w-max m-auto custom-transition mb-4'
						to={`/projects/${project.id}`}>
						{t("project details")}
						{i18n?.language === "ar" ? (
							<FiArrowDownLeft className='group-hover:translate-y-1 transition-transform' />
						) : (
							<FiArrowDownRight className='group-hover:translate-y-1 transition-transform' />
						)}
					</Link>
				</div>
			</Fade>
		</SwiperSlide>
	);

	return (
		<section className='projects-area bg-color pt-24 pb-24 md:px-12 px-4'>
			<div className='relative z-10'>
				<div className='flex justify-center items-center gap-2 mb-4'>
					<img
						loading='lazy'
						className='rotate-animate'
						src={OurSolIcon}
						alt='Projects Icon'
					/>
					<h3 className='text-second_color font-semibold md:text-4xl text-3xl'>
						{title}
					</h3>
				</div>
				<div className='mb-6'>
					<Fade direction='up' triggerOnce={true}>
						<p className='md:text-2xl text-xl md:w-[85%] w-full m-auto font-medium text-white text-center mb-3'>
							{description}
						</p>
					</Fade>
				</div>
				<div>
					<Swiper
						slidesPerView={1}
						spaceBetween={20}
						freeMode={true}
						navigation={true}
						loop={true}
						dir={i18n?.language === "ar" ? "rtl" : "ltr"}
						autoplay={{ delay: 2000, disableOnInteraction: false }}
						breakpoints={{
							992: { slidesPerView: 4, spaceBetween: 20 },
							768: { slidesPerView: 3, spaceBetween: 20 },
						}}
						modules={[FreeMode, Navigation, Autoplay]}
						className='projects-slides h-auto md:h-[350px] z-10 md:mb-0 mb-8'>
						{sliderData?.map(renderSwiperSlide)}
					</Swiper>
				</div>
				<div className='w-max m-auto'>
					<Fade
						direction={i18n?.language === "ar" ? "right" : "left"}
						triggerOnce={true}>
						<button
							className={`${
								i18n?.language === "en" ? "default-btn-ltr" : "default-btn-rtl"
							} default-btn white-btn`}
							onClick={() => navigate("/projects")}>
							{t("more projects")}
							{i18n?.language === "ar" ? (
								<HiOutlineArrowSmLeft className='rtl' />
							) : (
								<HiOutlineArrowSmRight className='ltr' />
							)}
							<span></span>
						</button>
					</Fade>
				</div>
			</div>
		</section>
	);
});

export default OurProjects;
